import { useState } from "react";
import { Bot, MessageSquare, Phone, Users, Sparkles } from "lucide-react";
import AIPalChat from "@/components/AIPalChat";

const PALS = [
  {
    id: "chatpal",
    name: "Chatpal",
    description: "Handles direct conversation, quick replies, and chat context.",
    icon: MessageSquare,
    color: "from-violet-500 to-purple-500",
  },
  {
    id: "callpal",
    name: "Callpal",
    description: "Summarizes calls, follow-ups, and voice-workflow actions.",
    icon: Phone,
    color: "from-emerald-500 to-teal-500",
  },
  {
    id: "groupspal",
    name: "Groupspal",
    description: "Tracks group conversations, threads, and shared decisions.",
    icon: Users,
    color: "from-blue-500 to-indigo-500",
  },
];

export default function AIPals() {
  const [activePal, setActivePal] = useState(PALS[0]);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="mb-8 flex items-center justify-between gap-4 flex-wrap">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 border border-violet-500/20 bg-violet-500/10 text-violet-300 text-xs uppercase tracking-[0.25em] mb-4">
              <Sparkles className="w-3 h-3" />
              AI Pals
            </div>
            <h1 className="font-['Barlow_Condensed'] text-4xl font-bold text-white">Assistant roster</h1>
            <p className="text-slate-400 mt-2 max-w-2xl">
              Pick an assistant for the conversation mode you need. Each pal keeps its own context and is already wired into the Comms Centre.
            </p>
          </div>
          <div className="flex items-center gap-2 px-3 py-2 bg-slate-900/80 border border-white/10">
            <Bot className="w-4 h-4 text-violet-300" />
            <span className="text-sm text-slate-300">{PALS.length} connected assistants</span>
          </div>
        </div>

        <div className="grid lg:grid-cols-[320px_minmax(0,1fr)] gap-6">
          <aside className="space-y-3">
            {PALS.map((pal) => {
              const Icon = pal.icon;
              const isActive = activePal.id === pal.id;

              return (
                <button
                  key={pal.id}
                  type="button"
                  onClick={() => setActivePal(pal)}
                  className={`w-full text-left p-4 border transition-colors ${
                    isActive ? "bg-white/5 border-white/20" : "bg-slate-900/80 border-white/10 hover:border-white/20"
                  }`}
                  data-testid={`pal-select-${pal.id}`}
                >
                  <div className="flex items-start gap-3">
                    <div className={`w-11 h-11 flex items-center justify-center bg-gradient-to-br ${pal.color}`}>
                      <Icon className="w-5 h-5 text-white" />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center justify-between gap-2">
                        <h2 className="font-semibold text-white">{pal.name}</h2>
                        {isActive && <span className="text-xs text-violet-300 uppercase tracking-[0.2em]">Active</span>}
                      </div>
                      <p className="text-sm text-slate-400 mt-1">{pal.description}</p>
                    </div>
                  </div>
                </button>
              );
            })}
          </aside>

          <section className="min-h-[760px]">
            <AIPalChat
              palId={activePal.id}
              palName={activePal.name}
              palIcon={activePal.icon}
              color={activePal.color}
            />
          </section>
        </div>
      </div>
    </div>
  );
}
